

































































































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import CourseItem from '@/views/media/course/components/course-item.vue';
import {CourseItemData} from '@/views/media/course/components/course-item';
import {COURSE_TEMPLATE_TYPES, ShowOptionMaps, TemplateOptions} from './course-filter';

@Component({
  components: {CourseItem}
})
export default class CourseCanvas extends Vue {
  /**标题*/
  @Prop()
  private contentOptionMap: TemplateOptions | undefined;
  /**
   * 课程信息
   * 第一个key为week表头,第二个key为time节点,value为课程数据
   */
  @Prop()
  private courseData: Map<string, Map<string, CourseItemData>> | undefined;
  /**课程表头部信息,用于遍历校验*/
  @Prop()
  private courseHeader: Array<string> | undefined;
  /**课程对应颜色,用于提示课程类型*/
  @Prop()
  private courseColor: Array<{ name: string; count: number; }> | undefined;
  /**字体大小*/
  @Prop()
  private titleSize: number | undefined;
  @Prop()
  private headSize: number | undefined;
  /**时间节点*/
  @Prop()
  private timeNode: Array<string> | undefined;
  /**显示微店码*/
  @Prop()
  private showMaps: ShowOptionMaps | undefined;


  @Prop()
  private templateType: COURSE_TEMPLATE_TYPES| undefined;

  /**课程编辑*/
  @Emit('courseClick')
  public courseClick(week: string, time: string) {
    return Promise.resolve({week: week, time: time});
  }

  get getCourseKeys(): Array<string> {
    return this.courseHeader!;
  }

  get getCourseData(): Map<string, Map<string, CourseItemData>> {
    return this.courseData!;
  }


  /**普通课程*/
  get getCourseGroup(): Map<string, Map<string, Map<string, CourseItemData>>> {
    let groupMap = new Map<string, Map<string, Map<string, CourseItemData>>>();
    let keys = this.getCourseKeys;
    this.timeNode?.forEach(node => {
      let group: Map<string, Map<string, CourseItemData>> = new Map<string, Map<string, CourseItemData>>();
      keys.forEach(key => {
        let map: Map<string, CourseItemData> = new Map<string, CourseItemData>();
        this.getCourseData.get(key)!.forEach((course: any) => {
          if (course.datetime === node) {
            map.set(course.datetime, course);
          }
        });
        group.set(key, map);
      });
      groupMap.set(node, group);
    });
    return groupMap;
  }

  /**提示数目显示*/
  get tipsNumber() {
    return this.contentOptionMap?.tips.length || 0 > 2;
  }

  /**剧目课程*/
  get courseTrainingGroup(): Map<string, Map<string, CourseItemData>> {
    let groupMap = new Map<string, Map<string, CourseItemData>>();
    this.timeNode?.forEach(node => {
      this.courseData!.get(node)!.forEach((value, key, course_map) => {
        groupMap.set(node, course_map);
      });
    });
    return groupMap;
  }


  get isEmpty(): boolean {
    let isEmpty = true;
    this.courseData?.forEach((item: any) => {
      if (item.size > 0) {
        isEmpty = false;
      }
    });
    return isEmpty;
  }


}
